import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Select, AutoComplete } from 'antd';

const { Option } = Select;

const formattedGarageOptions = (garages) =>
  garages
    .sort((a, b) => a.businessName?.localeCompare(b.businessName))
    .map((garage) => <Option key={garage.garageId}>{garage.businessName}</Option>);

export default function GarageFilter({ className, onSelect, garages, value }) {
  const [currentInput, setCurrentInput] = useState(null);

  const clearValues = () => {
    setCurrentInput(null);
    onSelect(null);
  };

  const onChange = (input) => {
    if (!input) {
      clearValues();
    }
    return setCurrentInput(input);
  };

  const getValue = () => {
    if (value === '' && currentInput) {
      // Handle 'clear all' from parent which doesn't know about `currentInput`
      clearValues();
      return null;
    }
    return currentInput || value;
  };

  return (
    <div className={`filter-container ${value ? 'active' : ''} ${className}`}>
      <img src="/assets/icons/filters/spanner.svg" alt="Garage filter" />
      <AutoComplete
        allowClear
        style={{ width: '100%' }}
        dropdownMatchSelectWidth={false}
        dataSource={formattedGarageOptions(garages)}
        placeholder="Select a garage"
        filterOption={(inputValue, option) =>
          option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
        onSelect={onSelect}
        onChange={onChange}
        value={getValue()}
      />
    </div>
  );
}

GarageFilter.propTypes = {
  className: PropTypes.string,
  onSelect: PropTypes.any.isRequired,
  garages: PropTypes.array.isRequired,
  value: PropTypes.string,
};

GarageFilter.defaultProps = {
  className: null,
  value: null,
};
